import React from 'react'

type HealthHeartIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const HealthHeartIcon = ({
  width = 20,
  height = 20,
  className,
  color = 'currentColor',
}: HealthHeartIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g transform="translate(0.206 1.223)">
      <path
        d="M13.6121 3.63102V8.2693M15.8867 5.95036L11.338 5.95035M17.57 2.0458C17.1207 1.58744 16.5873 1.22384 16.0001 0.97576C15.413 0.727685 14.7837 0.6 14.1481 0.6C13.5125 0.6 12.8832 0.727685 12.2961 0.97576C11.7089 1.22384 11.1755 1.58744 10.7262 2.0458L9.79372 2.99662L8.86127 2.0458C7.95371 1.12038 6.72281 0.60048 5.43934 0.60048C4.15587 0.60048 2.92496 1.12038 2.01741 2.0458C1.10986 2.97122 0.6 4.22637 0.6 5.53511C0.6 6.84386 1.10986 8.099 2.01741 9.02443L9.79372 16.9539L17.57 9.02443C18.0195 8.56628 18.3761 8.02231 18.6194 7.42361C18.8627 6.8249 18.9879 6.18318 18.9879 5.53511C18.9879 4.88704 18.8627 4.24533 18.6194 3.64662C18.3761 3.04791 18.0195 2.50395 17.57 2.0458Z"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)
